import React from "react";
import classNames from "classnames";
import { useDrag } from "react-dnd";
import tinycolor from "tinycolor2";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";

import Address from "../../shared/Address";
import Currency from "../../shared/Currency";
import styles from "./AvailableJobs.css";
import DisplayField from "../../shared/Event/DisplayField";

export const DraggableType = "job";

const shouldDisable = (job, activeCrew) =>
  activeCrew &&
  job.office &&
  !activeCrew.offices.some((o) => o.id === job.office.id);

const makeStyle = ({ color }) =>
  !color
    ? null
    : {
        backgroundColor: color,
        borderColor: tinycolor(color).darken(40),
        color: tinycolor(color).getBrightness() < 150 ? "#fff" : "#000",
      };

const Job = ({
  activeCrew,
  detailEnabled,
  financialEnabled,
  job,
  locationEnabled,
  onClick,
}) => {
  const disable = shouldDisable(job, activeCrew);
  const [, drag] = useDrag({
    item: { jobId: job.id, job, type: DraggableType },
  });
  return (
    <div
      className={classNames(styles.job, { [styles.disabled]: disable })}
      onDoubleClick={disable ? null : onClick}
      ref={drag}
    >
      <div>
        <div style={makeStyle(job)}>
          <h5
            style={{
              textAlign: "left",
              padding: "6px 8px",
              fontSize: "16px",
              fontFamily: "var(--font-family-Fira-Condensed)",
              margin: 0,
            }}
          >
            <b>{`${job.jobNumber || ""}`}</b>
          </h5>
        </div>
        <div
          className={styles.jobHeader}
          style={{ padding: "0px 8px 8px 8px" }}
        >
          <DisplayField group="general" field="jobName">
            <p>
              <b
                style={{
                  color: "var(--Neutral-850)",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >{`${job.name || ""}`}</b>
            </p>
          </DisplayField>
          {job.location && (
            <FormGroup className={styles.dataValuePair}>
              <ControlLabel className={styles.dataValuePairLabel}>
                Location
              </ControlLabel>
              <FormControl.Static
                className={styles.dataValuePairValue}
                componentClass={"div"}
              >
                {job.location}
              </FormControl.Static>
            </FormGroup>
          )}
          {job.office && (
            <DisplayField group="general" field="office">
              <FormGroup className={styles.dataValuePair}>
                <ControlLabel className={styles.dataValuePairLabel}>
                  Office
                </ControlLabel>
                <FormControl.Static
                  className={styles.dataValuePairValue}
                  componentClass={"div"}
                >
                  {job.office.name}
                </FormControl.Static>
              </FormGroup>
            </DisplayField>
          )}
          {locationEnabled && <Address address={job.address} styles={styles} />}
          {detailEnabled && job.salesperson && (
            <DisplayField group="details" field="salesperson">
              <FormGroup className={styles.dataValuePair}>
                <ControlLabel className={styles.dataValuePairLabel}>
                  Salesperson
                </ControlLabel>
                <FormControl.Static
                  className={styles.dataValuePairValue}
                  componentClass={"div"}
                >
                  {job.salesperson.firstName} {job.salesperson.lastName}
                </FormControl.Static>
              </FormGroup>
            </DisplayField>
          )}
          {detailEnabled && job.priorityNotes && (
            <DisplayField group="details" field="priorityNotes">
              <FormGroup className={styles.dataValuePair}>
                <ControlLabel className={styles.dataValuePairLabel}>
                  Priority Notes
                </ControlLabel>
                <FormControl.Static
                  className={styles.dataValuePairValue}
                  componentClass={"div"}
                >
                  {job.priorityNotes}
                </FormControl.Static>
              </FormGroup>
            </DisplayField>
          )}
          {financialEnabled && job.capacities && job.capacities.laborAmount && (
            <DisplayField group="financial" field="jobEstimatedLabor">
              <FormGroup className={styles.dataValuePair}>
                <ControlLabel className={styles.dataValuePairLabel}>
                  Est Labor
                </ControlLabel>
                <FormControl.Static
                  className={styles.dataValuePairValue}
                  componentClass={"div"}
                >
                  <Currency value={job.capacities.laborAmount} />
                </FormControl.Static>
              </FormGroup>
            </DisplayField>
          )}
        </div>
      </div>
    </div>
  );
};

export default Job;
